<template>
  <div class="label-container">
    <sub-paragraph :color="'dark-purple'">
      {{ title }}
    </sub-paragraph>
  </div>
</template>

<script>
import SubParagraph from "@/components/shared/text/SubParagraph.vue";

export default {
  name: "LabelCustom",
  components: {SubParagraph},
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  .label-container {
    width: fit-content;
    background-color: rgba(var(--color-purple-grey-rgba), .2);
    line-height: 140%;
  }

  @media (max-width: 3024px){
    .label-container {;
      padding: 2px 10px;
      border-radius: 18px;
    }
  }

  @media (max-width: 769px) {
    //iPhone 14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {

    .label-container {
      padding: 4px 24px;
      border-radius: 18px;
    }
  }

</style>